import { render } from "./Pd.vue?vue&type=template&id=35fa6522&scoped=true"
import script from "./Pd.vue?vue&type=script&lang=js"
export * from "./Pd.vue?vue&type=script&lang=js"

import "./Pd.vue?vue&type=style&index=0&id=35fa6522&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35fa6522"]])

export default __exports__